<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mGauge Default Settings</strong>
        </div> 

        <div>
          <b-row style="vertical-align: middle;padding-bottom:5px;">
             
            <slot v-if="showReportTitle">
              Template Id - {{activeReport.id}}
            </slot>

          </b-row>

          <div class="row mt-4" v-if="!initLoad">
            <div class="col">
              <b-card title="Card Title" no-body>
                <b-tabs v-model="wizardStep" @activate-tab="wizardTabClick" card>
                  <b-tab title="1. Calculation Settings" active>
                    <button id="btnNextCalcSetts" class="btn btn-primary pull-right mr-2" @click="wizardNextStep(1, 'Step1')">
                      <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                    </button>
                    <form class="validationForm" data-vv-scope="Step1" onsubmit="event.preventDefault(); return false;">
                      <b-row style="vertical-align: middle;padding-bottom:5px;" class="pt-2">
                        <b-col lg="6">
                          <div class="form-group row">
                            <label>Vehicle Set</label>
                            <dx-select-box id="selVehicleSet" style="width: 100%;" :items="vehicleSets" value-expr="id" display-expr="title" :value.sync="activeReport.vehicleSet"
                                           v-validate="{required: true}"
                                           name="Vehicle Set"
                                           :isValid="HasError('Step1.Vehicle Set')"
                                           :validationError="GetError('Step1.Vehicle Set')">

                            </dx-select-box>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col lg="3">
                          <label>Zip Code</label>
                          <dx-text-box id="inpZipCode" :value.sync="activeReport.zipCode"
                                       v-validate="{required: true, digits: 5}"
                                       name="Zip Code"
                                       :isValid="HasError('Step1.Zip Code')"
                                       :validationError="GetError('Step1.Zip Code')"></dx-text-box>
                        </b-col>
                        <b-col lg="3">
                          <label>Credit Score</label>
                          <dx-number-box id="inpCreditScore" v-model="activeReport.creditScore"
                                       v-validate="{required: true, digits: 3}"
                                       name="Credit Score"
                                       :isValid="HasError('Step1.Credit Score')"
                                       :validationError="GetError('Step1.Credit Score')"></dx-number-box>
                        </b-col>
                        <b-col lg="3">
                          <label>
                            Customer Cash
                            <slot v-if="activeReport.cashType !== 0" class="input-group-text ml-1 p-0"> (% of MSRP)</slot>
                          </label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select id="selCustCashType" v-model="activeReport.cashType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpCustomerCash" class="form-control" v-model="activeReport.cashDown"
                                           v-validate="{required: true, min_value: 0, max_value:999999}"
                                           name="Customer Cash"
                                           :min="0"
                                           :max="999999"
                                           :isValid="HasError('Step1.Customer Cash')"
                                           :validationError="GetError('Step1.Customer Cash')"></dx-number-box>
                          </div>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanMode !== 1">
                          <label>Annual Mileage</label>
                          <dx-select-box id="annualMileagedd" :items="annualMileageOptions" value-expr="value" display-expr="text" :value.sync="activeReport.annualMileage"
                                         v-validate="{required: true}"
                                         name="Annual Mileage"
                                         :wrapItemText="true"
                                         :accept-custom-value="true"
                                         @customItemCreating="customItemCreating($event)"
                                         :isValid="HasError('Step1.Annual Mileage')"
                                         :validationError="GetError('Step1.Annual Mileage')">
                          </dx-select-box>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2 pt-4">
                        <b-col lg="3">
                          <label>Scan Mode</label>
                          <dx-select-box id="scanModedd" :items="scanModeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanMode"
                                         v-validate="{required: true}"
                                         name="Scan Mode"
                                         :onValueChanged="ScanModeChange"
                                         :isValid="HasError('Step1.Scan Mode')"
                                         :validationError="GetError('Step1.Scan Mode')" />
                        </b-col>
                        <b-col lg="3">
                          <label>Scan Type</label>
                          <dx-select-box id="scanTypedd" :items="scanTypeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanType"
                                         v-validate="{required: true}"
                                         name="Scan Type"
                                         :isValid="HasError('Step1.Scan Type')"
                                         :validationError="GetError('Step1.Scan Type')" />
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 0">
                          <label>Adjustment Type</label>
                          <b-form-radio-group id="radGroupAdjustType" v-model="activeReport.adjustmentType" style="padding-top:6px;" :options="[
                                          {text: 'MSRP',value: 0},
                                          {text: 'Invoice',value: 1},
                                          ]">
                          </b-form-radio-group>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 0">
                          <label>Adjustment Value</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpAdjustValueSellPrice" class="form-control" v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: -999999, max_value:999999}"
                                         name="Adjustment Value"
                                         :isValid="HasError('Step1.Adjustment Value')"
                                         :validationError="GetError('Step1.Adjustment Value')"></dx-number-box>
                          </div>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 1">
                          <label>Desired Profit</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpDesiredProfit" class="form-control" v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: 0, max_value:999999}"
                                         name="Adjustment Value"
                                         :isValid="HasError('Step1.Adjustment Value')"
                                         :validationError="GetError('Step1.Adjustment Value')"></dx-number-box>
                          </div>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step1')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="2. Lender Options">
                    <b-row>
                      <b-col md="12" class="mb-2 p-0">
                        <button id="btnBack" class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNext" class="btn btn-primary pull-right" @click="wizardNextStep(2, 'Step2')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step2" onsubmit="event.preventDefault(); return false;">
                      <b-row class="m-0">
                        <b-col lg="12" class="m-0 ">
                          <b-card class="m-0 mb-1 p-0">
                            <div class="m-0 pt-2" style="float:left;" v-if="!activeReport.applicableCaptiveLender"><strong>Tracked Lender</strong></div>
                            <div class="dx-fieldset my-0" style="float:left; width:50%;">
                              <div class="dx-field" v-if="!activeReport.applicableCaptiveLender">
                                <dx-lookup id="selTrackedLender" :items="availableLenders" style="z-index:99999"
                                           :value.sync="activeReport.trackedLender"
                                           :show-popup-title="true"
                                           display-expr="Name"
                                           placeholder="Select Tracked Lender"
                                           title="Select Tracked Lender"
                                           v-validate="{required: true}"
                                           name="Tracked Lender"
                                           :isValid="HasError('Step2.Tracked Lender')"
                                           :validationError="GetError('Step1.Tracked Lender')" />
                              </div>
                            </div>
                            <div class="m-0 pt-2" style="float:left;">
                              <span v-if="!activeReport.applicableCaptiveLender">or </span><span>Track Captive Lenders: </span>
                              <c-switch id="trackCaptLendSw" v-model="activeReport.applicableCaptiveLender" @change="clickApplicableCaptiveLender($event)" type="text" variant="primary" on="On"
                                        off="Off" :pill="true" />
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="7">
                          <b-card no-body >
                            <div slot="header" class="m-0">                              
                              <strong>Compared Lenders</strong>
                              <b-form-input id="inpCompLenderSearch" v-model="lenderSearch" class="ml-4 w-50" style="display:inline" placeholder="Type to Search" />
                            </div>                            
                            <b-row style="height: 324px; overflow: auto" class="m-0 p-0">
                              <b-col lg="12" class="m-0 p-0">
                                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">Lender Name</th>
                                      <th aria-colindex="3" style="position: sticky; top: 0; z-index:200;">
                                        <button @click="selectAllComparedLenders" class="btn btn-primary text-white btn-sm">
                                          <i title="Select/Unselect All Compared Lenders" class="fa fa-check-square"></i>
                                          {{ !activeReport.comparedLenders.length ? 'Select All' : 'Unselect All' }}
                                        </button>                                        
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!availableLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No lenders found.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l, i) in filteredLenders">
                                      <td>
                                        {{l.Name}}
                                      </td>
                                      <td>
                                        <c-switch :id="l.Name" v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>                             
                          </b-card>
                        </b-col>
                        <b-col lg="5">
                          <b-card no-body >
                            <div slot="header" style="height:35px;">
                              <div class="pt-2">
                                <strong>Selections</strong>
                              </div>                             
                            </div>
                            <b-row style="height: 324px; overflow: auto" class="m-0 p-0">
                              <b-col lg="12" class="m-0 p-0">
                                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr style="height:37px">
                                      <th aria-colindex="1">Lender Name</th>
                                      <th aria-colindex="3"></th>
                                    </tr>
                                  </thead>
                                  <tbody> 
                                    <tr v-if="!selectedComparedLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No compared lenders selected.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l, i) in selectedComparedLenders">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step2')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="3. Rebate Options">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextRebOptions" class="btn btn-primary pull-right" @click="wizardNextStep(3, 'Step3')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <b-alert v-if="VehicleSetIsNew" variant="info" dismissed="false" class="w-30" :show="true">
                      Note: These are conditional rebates.
                    </b-alert>
                    <b-alert v-else variant="info" dismissed="false" class="w-30" :show="true">
                      Note: There are no rebates for used vehicles.
                    </b-alert>
                    <form class="validationForm" data-vv-scope="Step3" onsubmit="event.preventDefault(); return false;">
                      <b-row v-bind:class="{'disableRebates': !VehicleSetIsNew}">
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="4">Loyalty</b-form-checkbox>
                              <b-form-checkbox value="5">Conquest</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="2">College Graduate</b-form-checkbox>
                              <b-form-checkbox value="1">Military</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step3')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="4. Target Acquisition Settings">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextTargAcqSetts" class="btn btn-primary pull-right" @click="wizardNextStep(4, 'Step4')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row> 
                    <form class="validationForm" data-vv-scope="Step4" onsubmit="event.preventDefault(); return false;">
                      <b-alert variant="info" dismissed="false" class="text-center" :show="true">
                        <b-row>
                          <b-col v-bind:class="{'col-md-9': activeReport.scanMode !== 1, 'col-md-4': activeReport.scanMode === 1, 'disableTA': !activeReport.useTargetAcquisition }" class="text-center">
                            <div class="my-2" style="float: left;">Target Payment:&nbsp;</div>
                            <div style="float:left; max-width:70px;">
                              <b-form-select v-model="activeReport.targetAcquisition.targetPaymentType"
                                             :options="[{text:'$', value:0}, {text:'%', value:1}]">
                              </b-form-select>
                            </div>
                            <div style="float:left; max-width:120px;">
                              <dx-number-box class="form-control" v-model="activeReport.targetAcquisition.targetPayment"
                                             v-validate="{required: activeReport.useTargetAcquisition}"
                                             name="Target Payment"
                                             :min="-99999"
                                             :max="99999"
                                             :isValid="HasError('Step4.Target Payment')"
                                             :validationError="GetError('Step4.Target Payment')" />
                            </div>
                          </b-col>
                          <slot v-if="activeReport.scanMode === 1">
                            <b-col md="3" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">
                              <div class="my-2" style="float: left;">Min Interest Rate:&nbsp;</div>
                              <div style="float:left; max-width:70px;">
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.lowerInterestRate"
                                               id="lowerInterestRate"
                                               :onValueChanged="CalcRateChange"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Interest Rate" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Interest Rate')"
                                               :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col md="3" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">
                              <div class="my-2" style="float: left;">Max Interest Rate:&nbsp;</div>
                              <div style="float:left; max-width:70px;">
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               id="raiseInterestRate"
                                               :onValueChanged="CalcRateChange"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Rate" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Rate')"
                                               :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col v-bind:class="{'disableTA': activeReport.useAverageReport, 'col-md-3': activeReport.scanMode !== 1, 'col-md-2': activeReport.scanMode === 1 }" class="my-2">
                            <div style="float:right;">
                              Enabled:
                              <c-switch id="swEnabled" v-model="activeReport.useTargetAcquisition" class="mb-0" type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                      </b-alert>
                      <div v-if="activeReport.scanMode === 0" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">

                        <div class="ml-5 mt-4">
                          <i class="fa fa-arrow-down"></i> Lower Payment By:
                        </div>
                        <b-row>
                          <b-col xs="6" class="text-center">
                            <div>Lowering Rate: {{ activeReport.targetAcquisition.lowerRatePercentInRoll}}%</div>
                          </b-col>
                          <b-col xs="6" class="text-center">
                            <div>Increasing Residual Value: {{ 100 - activeReport.targetAcquisition.lowerRatePercentInRoll}}%</div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12">
                            <div class="dx-field">
                              <DxSlider v-model="activeReport.targetAcquisition.lowerRatePercentInRoll" :min="0" :max="100" />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 0">
                          </b-col>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 1">
                            <b-row>
                              <b-col xs="4">
                                <div>
                                  Min Money Factor:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.lowerMoneyFactor"
                                                 id="lowerMoneyFactor"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Min Money Factor"
                                                 :min="0"
                                                 :max="100"
                                                 :isValid="HasError('Step4.Min Money Factor')"
                                                 :validationError="GetError('Step4.Min Money Factor')"></dx-number-box>
                                </div>
                              </b-col>
                              <b-col xs="4" class="text-center">
                                <div>
                                  Min Interest Rate:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.lowerInterestRate"
                                                 id="lowerInterestRate"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Min Interest Rate" :min="0" :max="100"
                                                 :isValid="HasError('Step4.Min Interest Rate')"
                                                 :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <slot v-else>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 2">
                              <div>
                                Min Money Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerMoneyFactor"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Money Factor" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Money Factor')"
                                               :validationError="GetError('Step4.Min Money Factor')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 3">
                              <div class="text-center">
                                Min Interest Rate:
                                <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Interest Rate" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Interest Rate')"
                                               :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 4">
                            <div class="text-center">
                              Min Interest Factor:
                              <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerInterestRate"
                                             v-validate="{required: activeReport.useTargetAcquisition}"
                                             name="Min Interest Factor" :min="0" :max="100"
                                             :isValid="HasError('Step4.Min Interest Factor')"
                                             :validationError="GetError('Step4.Min Interest Factor')"></dx-number-box>
                            </div>
                          </b-col>

                          <b-col xs="4" class="text-center">
                            <div>
                              Max RV% Adjustment : <br v-if="lenderCalcType === 1" />
                              <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerResidualPctAdj"
                                             v-validate="{required: activeReport.useTargetAcquisition, min_value:0, max_value:99}"
                                             :min="1"
                                             :max="99"
                                             :step="1"
                                             format="##"
                                             name="Max RV percent"
                                             :isValid="HasError('Step4.Max RV percent')"
                                             :validationError="GetError('Step4.Max RV percent')"></dx-number-box>
                            </div>
                          </b-col>
                          <b-col xs="4" class="text-center">
                            <div>
                              Maintain Ratios at Limits : <br />
                              <c-switch v-model="activeReport.targetAcquisition.lowerMaintainRatiosAtLimits"
                                        type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                        <hr />
                        <div class="ml-5 mt-4">
                          <i class="fa fa-arrow-up"></i> Raise Payment By:
                        </div>
                        <b-row>
                          <b-col xs="6" class="text-center">
                            <div>Increasing Rate: {{ activeReport.targetAcquisition.raiseRatePercentInRoll}}%</div>
                          </b-col>
                          <b-col xs="6" class="text-center">
                            <div>Lowering Residual Value: {{ 100 - activeReport.targetAcquisition.raiseRatePercentInRoll}}%</div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12">
                            <div class="dx-field">
                              <DxSlider v-model="activeReport.targetAcquisition.raiseRatePercentInRoll" :min="0" :max="100" />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 0">
                          </b-col>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 1">
                            <b-row>
                              <b-col xs="4">
                                <div>
                                  Max Money Factor:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.raiseMoneyFactor"
                                                 id="raiseMoneyFactor"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Max Money Factor" :min="0" :max="99"
                                                 :isValid="HasError('Step4.Max Money Factor')"
                                                 :validationError="GetError('Step4.Max Money Factor')"></dx-number-box>
                                </div>
                              </b-col>
                              <b-col xs="4" class="text-center">
                                <div>
                                  Max Interest Rate:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.raiseInterestRate"
                                                 id="raiseInterestRate"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Max Interest Rate" :min="0" :max="99"
                                                 :isValid="HasError('Step4.Max Interest Rate')"
                                                 :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <slot v-else>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 2">
                              <div>
                                Max Money Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseMoneyFactor"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Money Factor" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Money Factor')"
                                               :validationError="GetError('Step4.Max Money Factor')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 3">
                              <div>
                                Max Interest Rate:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Rate" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Rate')"
                                               :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 4">
                              <div>
                                Max Interest Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Factor" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Factor')"
                                               :validationError="GetError('Step4.Max Interest Factor')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col xs="4" class="text-center">
                            <div>
                              Min RV% : <br v-if="lenderCalcType === 1" />
                              <dx-number-box class="centerDiv" style="max-width: 100px;"
                                             v-model="activeReport.targetAcquisition.raiseResidualPctAdj"
                                             v-validate="{required: activeReport.useTargetAcquisition, min_value:20, max_value:99}"
                                             :min="20"
                                             :max="99"
                                             :step="1"
                                             format="##"
                                             name="Min RV percent"
                                             :isValid="HasError('Step4.Min RV percent')"
                                             :validationError="GetError('Step4.Min RV percent')"></dx-number-box>
                            </div>
                          </b-col>
                          <b-col xs="4" class="text-center">
                            <div>
                              Maintain Ratios at Limits : <br />
                              <c-switch v-model="activeReport.targetAcquisition.raiseMaintainRatiosAtLimits"
                                        type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step4')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="5. Report Settings">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <b-col md="12" class="mb-4 p-0">
                          <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                            <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                          </button>                          
                        </b-col>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step5" onsubmit="event.preventDefault(); return false;">
                      <b-row v-if="activeReport.scanMode === 0" class="w-75">
                        <label>Lease Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 v-validate="{required: true}"
                                                 name="Terms"
                                                 :isValid="HasError('Step5.Terms')">
                            <b-form-checkbox v-for="t in leaseTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <b-row v-if="activeReport.scanMode === 1" class="w-75">
                        <label>Retail Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 v-validate="{required: true}"
                                                 name="Terms"
                                                 :isValid="HasError('Step5.Terms')">
                            <b-form-checkbox v-for="t in retailTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <label>Options:</label>
                      <b-row>
                        <b-form-checkbox class="ml-4" v-model="activeReport.includeOnlyTermsWithTrackedLenderPresent">Only display terms that include Tracked Lender Programs</b-form-checkbox>
                      </b-row>
                      <b-row>
                        <b-form-checkbox id="chkUseAvgReport" class="ml-4" v-bind:class="{'disableTA': accessAverageReportOnly}" v-model="activeReport.useAverageReport" @change="ChangeUseAverageReport">Use Average Report</b-form-checkbox>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col lg="3" class="p-0">
                          <label class="mt-2">Group Results By:</label>
                          <b-form-select id="groupByDropDown" v-model="activeReport.groupBy" :options="[
                                           {text:'None (Recommended)', value:0},
                                           {text:'Make and Model', value:1},
                                           {text:'Vehicle Class', value:2},
                                           {text:'Vehicle Category', value:4},
                                           {text:'Vehicle Class and Category', value:3}
                                           ]">
                          </b-form-select>
                        </b-col>
                        <b-col lg="3">
                          <label class="mt-2">Display {{ scanModeOptions[activeReport.scanMode].text }} Programs</label>
                          <b-form-select id="displayProgramOptionsd" :options="displayProgramOptions" v-model="activeReport.displayProgramOption"
                                         v-validate="{required: true}"
                                         name="Display Program Options" />
                        </b-col>
                        <b-col lg="3">
                          <label class="mt-2">Sort By:</label>
                          <b-form-select id="sortByDropDown" v-model="activeReport.sortBy" :options="[
                                           {text:'Spread $', value:0},
                                           {text:'Spread %', value:1},
                                           {text:'Payment Value Index (PVI)', value:3},
                                           {text:'Best Payment', value:5},
                                           {text:'MSRP', value:4},
                                           {text:'Vehicle (Year, Make, Model, Trim)', value:2},
                                           ]">
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col lg="3" class="p-0">
                          <label class="mt-2">Template Category</label>
                          <b-form-select v-model="activeReport.CategoryId" :options="mGauge_Categories"
                                         value-field="CategoryId"
                                         text-field="CategoryName">
                          </b-form-select>
                        </b-col>
                        <b-col lg="3">
                            <label class="mt-2">Report Category</label>
                            <b-form-select v-model="activeReport.DefaultHistoryCategoryId" :options="ReportHistoryCategories"
                                           value-field="CategoryId"
                                           text-field="CategoryName">
                            </b-form-select> 
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step5')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div> 
                  </b-tab>                 
                </b-tabs>
              </b-card>
            </div>
          </div>
          <b-row class="mx-2">
            <b-col md="12">
              <button class="btn btn-primary" @click="saveReportTemplate">
                <i class="fa fa-save"></i> <strong class="text-white">Save</strong>
              </button>
              <slot v-if="activeReport.id >0">
                <button class="btn btn-danger text-white" @click="deleteReportTemplate">
                  <i title="Delete" class="fa fa-trash-o fa-lg"></i> <strong>Delete</strong>
                </button>
              </slot>
            </b-col>
          </b-row>
        </div>

      </b-card>
    </div> 

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import moment from 'moment' 

// eslint-disable-next-line no-unused-vars
import {Validator} from 'vee-validate'

import {
  DxTextBox,
  DxSlider,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox,
  DxDateBox,
  DxButton,
  DxList,
  DxTagBox
} from 'devextreme-vue'
import DxPopup, {DxToolbarItem} from 'devextreme-vue/popup'
  import { confirm, alert } from 'devextreme/ui/dialog'

const customRange = {
  getMessage (field, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      return `Value of the field ${field} should be between ${min} and ${max}`
    }
    return `Check validator for a field ${field}`
  },
  validate (value, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let v = parseFloat(value + '')
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      // console.log(`value: ${JSON.stringify(v)} min: ${JSON.stringify(min)} max: ${JSON.stringify(max)}`)
      if (v >= min && v <= max) {
        return true
      }
    }
    return false
  }
}
Validator.extend('customRange', customRange)

export default {
  name: 'mGaugeDefaultSettings',
  components: {
    loading,
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    cSwitch,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxButton,
    DxList,
    DxTagBox
  },
  created() {
    this.initLoad = true
    this.Init()
    window.addEventListener('keydown', this.HandleTestValues)
  },
  data () {    
    return {
      initLoad: true,
      mGauge_Categories: [],
      ReportHistoryCategories: [],  
      errMsg: '',
      displayingData: false,
      changesSaved: true, 
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      lenderSearch: '',
      wizardStep: 0,
      wizardStepToChange: 0,        
      searchValue: '', 
      vehicleSets: [],
      activeReport: {}, 
      annualMileageOptions: [
        { text: '2,500', value: '2500' },
        {text: '5,000', value: '5000'},
        {text: '7,500', value: '7500'},
        { text: '10,000', value: '10000' },
        { text: '10,500', value: '10500' },
        { text: '12,000', value: '12000' },
        { text: '13,500', value: '13500' },
        { text: '15,000', value: '15000' },
        { text: '16,500', value: '16500' },
        { text: '18,000', value: '18000' },
        { text: '19,500', value: '19500' }
      ],
      showCustomMileage: false,
      scanModeOptions: [
        {text: 'Lease', value: 0},
        {text: 'Retail', value: 1}
      ],
      scanModeSelect: [
        { text: 'All', value: 'All' },
        { text: 'Lease', value: 'Lease' },
        { text: 'Retail', value: 'Retail' }
      ],
      scanMode: 'All',
      scanTypeOptions: [
        {text: 'Profit', value: 1},
        {text: 'Selling Price', value: 0}
      ],
      displayProgramOptions: [
        { text: 'Special and Standard', value: 0 },
        { text: 'Special Only', value: 1 },
        { text: 'Standard Only', value: 2 }
      ],  
      accessAverageReportOnly: false,
      retailTerms: ['12', '18', '24', '30', '36', '42', '48', '54', '60', '63', '66', '72', '75', '78', '84', '88', '90', '96'],
      leaseTerms: ['12', '15', '18', '21', '24', '25', '26', '27', '28', '30', '31', '32', '33', '34', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '48', '49', '50', '51', '52', '54', '57', '60', '66', '72'],
      availableLenders: [],
      showReportTitle: false
    }
  },
  methods: {
    async Init() {
      let self = this
      try {
        self.boolLoading = true
        let response = await axios.get('/api/mgauge/getdefaultsettings')
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined && response.data !== null) {

            self.accessAverageReportOnly = response.data.accessAverageReportOnly
            self.vehicleSets = response.data.vehicleSets
            self.availableLenders = response.data.lenders
            self.mGauge_Categories = response.data.TemplateCategories
            self.ReportHistoryCategories = response.data.ReportHistoryCategories
            self.activeReport = response.data.DefaultTemplate

            let defcomparedLenders = response.data.DefaultTemplate.comparedLenders           

            if (self.accessAverageReportOnly) {
              self.activeReport.useAverageReport = true
              self.activeReport.useTargetAcquisition = false
            }

            self.$validator.reset()
            self.wizardStep = 0

            self.availableLenders.forEach(function (i) {
              let selected = defcomparedLenders.filter(s => s.Name === i.Name)
              i.Compared = selected.length > 0               
            })

            self.trueValidateAllSilent(true)

            self.changesSaved = true

            self.boolLoading = false
          }
        }
        self.initLoad = false
      }
      catch(error) {
        if (error.response.status === 403) { this.$router.push('/login') }
        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      }
    },  
    handleSubmit () {
      if (!this.$refs.form.checkValidity()) {
        return
      }  

      this.saveReportTemplate() 
    },
    customItemCreating (data) {
      if (!data.text || isNaN(data.text)) {
        data.customItem = null
        return
      }

      let amOption = {text: data.text, value: data.text.replace(',', '')}
      this.annualMileageOptions.push(amOption)
      data.customItem = amOption
    },
    selectallLeaseTerms (SelectAll) {
      let self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.leaseTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    },
    selectallRetailTerms (SelectAll) {
      let self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.retailTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    }, 
       
    updateComparedLender (lender) {
      let self = this
      self.availableLenders.forEach(item => {
        if (item.Name.toLowerCase() === lender.Name.toLowerCase()) {
          item.Compared = lender.Compared
        }
      })
    },
    CalcRateChange (e) {
      if (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null) {
        if (!this.activeReport.trackedLender.hasMoneyFactor || !this.activeReport.trackedLender.hasInterestRate) { return }
      }
      if (isNaN(e.value) || e === '') { return }

      let changedNumber = parseFloat(e.value)
      let ta = this.activeReport.targetAcquisition

      switch (e.element.id) {
        case 'lowerMoneyFactor':
          if (isNaN(ta.lowerInterestRate) || ta.lowerInterestRate === null) { ta.lowerInterestRate = changedNumber * 2400.0 }
          break
        case 'raiseMoneyFactor':
          if (isNaN(ta.raiseInterestRate) || ta.raiseInterestRate === null) { ta.raiseInterestRate = changedNumber * 2400.0 }
          break
        case 'lowerInterestRate':
          if (isNaN(ta.lowerMoneyFactor) || ta.lowerMoneyFactor === null) { ta.lowerMoneyFactor = parseFloat((changedNumber / 2400.0).toFixed(5)) }
          break
        case 'raiseInterestRate':
          if (isNaN(ta.raiseMoneyFactor) || ta.raiseMoneyFactor === null) { ta.raiseMoneyFactor = parseFloat((changedNumber / 2400.0).toFixed(5)) }
          break
      }
    },
    ScanModeChange () {
      let self = this
      if (self.displayingData === false) { self.activeReport.terms = [] }
    },
     
    setLegacyTerms () {
      let self = this
      try {
        if (self.activeReport.leaseTerms !== undefined && self.activeReport.leaseTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.leaseTerms.length; i++) {
            let term = self.activeReport.leaseTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
      try {
        if (self.activeReport.retailTerms !== undefined && self.activeReport.retailTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.retailTerms.length; i++) {
            let term = self.activeReport.retailTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
    },
    async saveReportTemplate () {
      let self = this 
       
      const isValid = await self.trueValidateAll()
      self.canRunReport = isValid
      if (isValid) {
        
        self.updateComparedLenders()

        //console.log(JSON.stringify(self.activeReport))

        axios.post('/api/mgauge/savedefaulttemplate', self.activeReport)
          .then(response => {
            self.boolLoading = false 
            self.changesSaved = true
            var msg = 'Default Settings have been saved'
              notify(msg, 'success', 3500)  
 
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.$router.push('/login')
            }
            else {
              this.errMsg = 'There was an error getting data : ' + error
            }

            self.boolLoading = false
            self.showDismissibleAlert = true
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    }, 
    deleteReportTemplate () {
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/deletereporttemplate', this.activeReport)
            .then(response => {              
              notify('Default Settings have been deleted', 'success', 3500)              
              this.Init()
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
    },
    trueValidateAllSilent (resetNeeded) {
      let self = this
      if (resetNeeded === undefined || resetNeeded === null) {
        resetNeeded = true
      }
      let validations = []
      validations.push(self.$validator.validate('Title.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step1.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step2.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step3.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step4.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step5.*', undefined, {silent: true}))

      return Promise.all(validations).then(results => {
        const retValue = results.every(r => r)

        if (resetNeeded === true) {
          self.$validator.reset('Title.*')
          self.$validator.reset('Step1.*')
          self.$validator.reset('Step2.*')
          self.$validator.reset('Step3.*')
          self.$validator.reset('Step4.*')
          self.$validator.reset('Step5.*')
        }
        return retValue
      })
    },
    trueValidateAll () {
      let self = this
      let validations = []
      validations.push(self.$validator.validateAll('Title'))
      validations.push(self.$validator.validateAll('Step1'))
      validations.push(self.$validator.validateAll('Step2'))
      validations.push(self.$validator.validateAll('Step3'))
      validations.push(self.$validator.validateAll('Step4'))
      validations.push(self.$validator.validateAll('Step5'))
      
      return Promise.all(validations).then(results => results.every(r => r))
    },
    
    clickApplicableCaptiveLender (event) {
      this.availableLenders.forEach(function (i) {
        i.Tracked = false
      })
      this.activeReport.trackedLender = null
      this.activeReport.applicableCaptiveLender = event
      this.activeReport.useTargetAcquisition = false
      this.changesSaved = false
    },
    selectAllComparedLenders () {
      if (this.activeReport.comparedLenders && this.activeReport.comparedLenders.length) {
        this.availableLenders.forEach(function (i) {
          i.Compared = false
        })
      } else {
        this.availableLenders.forEach(function (i) {
          i.Compared = true
        })
      }
      this.updateComparedLenders()
      this.changesSaved = false
    },
    updateComparedLenders () {
      this.activeReport.comparedLenders = this.selectedComparedLenders
    },

    wizardBackStep () {
      let self = this
      self.wizardStep = self.wizardStep - 1
      // self.wizardBackStepClicked = true
    },

    async wizardTabClick (newTabIndex, prevTabIndex, evt) {
      let self = this
      /*
      if (self.wizardStepToChange !== newTabIndex) {
        evt.preventDefault()
      }
      let validateTab = parseInt(parseInt(prevTabIndex) + 1)
      let validationTarget = 'Step' + validateTab

      self.canRunReport = await self.trueValidateAllSilent(false)

      let isValid = await self.$validator.validateAll(validationTarget)
      if (isValid) {
        // self.changesSaved = false
        self.wizardStepToChange = newTabIndex
        self.wizardStep = newTabIndex
      }*/

      self.wizardStepToChange = newTabIndex
      self.wizardStep = newTabIndex
      return false
    },
    async wizardNextStep (tabID, validationTarget) {
      // console.log(`tabID ${tabID} validationTarget ${validationTarget}`)
      let self = this
      // console.log(`0 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)
      /*self.canRunReport = await self.trueValidateAllSilent(false)

      // console.log(`1 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)

      let promise = new Promise(async (resolve, reject) => {
        // console.log(`2 tabID ${tabID} validationTarget ${validationTarget}`)

        const isValid = await self.$validator.validateAll(validationTarget)
        // console.log(`isValid: ${JSON.stringify(isValid)}`)
        if (isValid === true) {
          resolve(isValid)
        } else {
          reject(isValid)
        }
      })

      promise.then(value => {
        // console.log(`5 tabID ${tabID} validationTarget ${validationTarget}`)
        // self.changesSaved = false
        self.wizardStep = parseInt(tabID + '')
      }, reason => {
        // console.log(`6 tabID ${tabID} validationTarget ${validationTarget}`)
      })*/

      // console.log(`4 tabID ${tabID} validationTarget ${validationTarget}`)
      self.wizardStep = parseInt(tabID + '')
      return undefined
    },
    ChangeUseAverageReport () {
      this.activeReport.useTargetAcquisition = false
    },
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return {message: err}
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    },
    HandleTestValues(e) {
      let self = this
      if (e.ctrlKey === true && e.shiftKey === true && e.altKey === true && e.key === 'H') {
          self.showReportTitle = true
        }
    }
  },
  computed: {
    VehicleSetIsNew () {
      let self = this
      if (self.activeReport.vehicleSet === undefined || self.activeReport.vehicleSet === null) { return true }
      let vehicleSet = self.vehicleSets.find(vs => vs.id === self.activeReport.vehicleSet)
      if (vehicleSet === undefined || vehicleSet === null) { return true }
      return vehicleSet.isnew
    },    
    lenderCalcType () {
      if (this.activeReport.applicableCaptiveLender === true) {
        return this.activeReport.scanMode === 0 ? 2 : 3
      }
      if (this.activeReport.scanMode === 1) {
        return 3
      }

      let rtnValue = 0
      let hasMF = false
      let hasIR = false

      // let i = this.activeReport.trackedLender

      if (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null) {
        if (this.activeReport.trackedLender.hasMoneyFactor) {
          hasMF = true
        }
        if (this.activeReport.trackedLender.hasInterestRate) {
          hasIR = true
        }
      }

      if (hasIR) {
        rtnValue = 3
      }
      if (hasMF) {
        rtnValue = 2
      }
      if (hasMF && hasIR) {
        rtnValue = 1
      }
      if (!hasMF && !hasIR) {
        rtnValue = 2
      }
      if (this.activeReport.trackedLender !== undefined &&
        this.activeReport.trackedLender !== null &&
        this.activeReport.trackedLender.Name === 'Ford Motor Credit') {
        rtnValue = 4
      }

      return rtnValue
    },
    selectedComparedLenders () {
      return this.availableLenders.filter(f => {
        return f.Compared && (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null ? f.Name !== this.activeReport.trackedLender.Name : true)
      })
    },
    filteredLenders () {
      return this.availableLenders.filter(item => {
        return item.Name.toLowerCase().indexOf(this.lenderSearch.toLowerCase()) > -1
      })
    }
  },
  watch: {
     
    activeReport:
    {
      handler (newVal, oldVal) {
        this.changesSaved = false
      },
      deep: true
    }, 
    showCustomMileage: function (val, oldVal) {
      let self = this
      let annValue = 0
      if (val !== true && val !== 'true') {
        annValue = parseInt(self.activeReport.annualMileage)
        // console.log(`val: ${val} oldVal: ${oldVal} annValue: ${annValue}`)
        switch (annValue) {
          case 2500:
            return
          case 7500:
            return
          case 10000:
            return
          case 12000:
            return
          case 15000:
            return
          default:
            if (annValue >= 15000) {
              self.activeReport.annualMileage = '15000'
            } else if (annValue >= 12000) {
              self.activeReport.annualMileage = '12000'
            } else if (annValue >= 10000) {
              self.activeReport.annualMileage = '10000'
            } else if (annValue >= 7500) {
              self.activeReport.annualMileage = '7500'
            } else {
              self.activeReport.annualMileage = '2500'
            }
        }
      }
    }
  },
  filters: {
    formatDate: function (str) {
      if (!str) { return '' }
      str = new Date(str)
      return moment(String(str)).format('MM/DD/YY hh:mm A')
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('keydown', self.HandleTestValues)
  },
  beforeRouteLeave (to, from, next) {
    // console.log(`${from} -> ${to}`)
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },

  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style scoped>
  .disabledTab {
    pointer-events: none;
  }

  .dx-overlay-content {
    min-width: initial !important;
  } 

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .dx-widget .dx-slider-handle {
    background-color: #34b9a7;
  }

  .dx-slider-bar {
    background: #4bc300;
  }

  .centerDiv {
    margin-left: auto;
    margin-right: auto;
  }

  .vcenter {
    margin-top: auto;
    margin-bottom: auto;
  }

  .disableTA {
    pointer-events: none;
    opacity: 0.2;
  }

  .disableRebates {
    pointer-events: none;
    opacity: 0.2;
  }

  .numbercenter {
     text-align: center;
}    

  .categories {
    display: flex;
    flex: 2;
    flex-flow: column;
    width: 250px;
    max-height:700px;
  }

  .category_action {
    display: flex;
    flex: 2;
    margin-right: 10px;
  }

  .category_title {
    display: flex;
    flex: 10;
    margin-left: 10px;
  }

  .report_id {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 10px;
  }

  .report_template_name {
    display: flex;
    flex-flow: column;
    flex: 5;
    padding-left: 3px;
  }

  .report_user {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_category {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_is_active {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_date {
    display: flex;
    flex-flow: column;
    flex: 2;
    padding-left: 3px;
  }

  .report_time {
    display: flex;
    flex-flow: column;
    flex: 1;
  }

  .report_xls {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_html {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_json {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_action {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGaugeDefaultSettings.vue